import { Component } from '@angular/core';

@Component({
  selector: 'app-vault-receive-addupdate',
  templateUrl: './vault-receive-addupdate.component.html',
  styleUrl: './vault-receive-addupdate.component.scss'
})
export class VaultReceiveAddupdateComponent {

}
